export default {
  props: {
    cart: {
      type: Object,
      required: true,
    }
  }
}



// WEBPACK FOOTER //
// ./public/themes/frontend/uikit3/extensions/rubinred/ecommerce/assets/js/mixins/CartAwareComponent.js